import { configAnalytics } from '../configs';
import { initialProps } from '../configs/initialProps';
import { AnalyticsWrapperProps } from '../types/configs';

/**
 * Legacy wrapper component/helper that configures QAL and returns its children.
 *
 * Prefer calling `configAnalytics` directly during app bootstrap for new applications. This wrapper
 * applies the same initial props/default handling, calls `configAnalytics(config, true)` in browser
 * runtimes, and returns `children` unchanged. It does nothing during SSR because `window` is absent.
 *
 * @param props - QAL configuration props plus `children`.
 * @returns The supplied `children`.
 */
const AnalyticsWrapper = ({
  appEnv = '',
  appName = '',
  appPartner = '',
  appVersion = '',
  appType = '',
  appProduct = '',
  initialData = {},
  isAuthenticated = false,
  basePagePath = '',
  shouldReset = false,
  unitTestMode = false,
  enableAdsEngagementTracking = true,
  enableQalInBuiltEngagementTracking = false,
  resetMilestoneFormEngagedDefault = true,
  enableApiStartEvent = true,
  enableMilestonesPersist = false,
  sendPageViewToDynatrace = true,
  sendQbeTrackMetaKeysToDynatrace = false,
  sendDataLayerKeysToDynatrace = [],
  sendQALErrorsToDynatrace = true,
  bypassPiiCheckKeys = [],
  ...restProps
}: AnalyticsWrapperProps) => {
  if (typeof window !== 'undefined') {
    const config = initialProps({
      appEnv,
      appName,
      appPartner,
      appVersion,
      appType,
      appProduct,
      initialData,
      isAuthenticated,
      basePagePath,
      shouldReset,
      unitTestMode,
      enableAdsEngagementTracking,
      enableQalInBuiltEngagementTracking,
      resetMilestoneFormEngagedDefault,
      enableApiStartEvent,
      enableMilestonesPersist,
      sendPageViewToDynatrace,
      sendQbeTrackMetaKeysToDynatrace,
      sendDataLayerKeysToDynatrace,
      sendQALErrorsToDynatrace,
      bypassPiiCheckKeys,
      ...restProps,
    });

    configAnalytics(config, true);
  }

  return restProps.children;
};

export default AnalyticsWrapper;
